import { createTicketHooks } from ".."


const useSubmitBtns = (isUser) => {
    const submitBtn = createTicketHooks.useSubmitBtn(isUser)
    const setAlert = createTicketHooks.useAlert()
    const cleanForm = createTicketHooks.useCleanForm()

    const submitBtns = [
        {
            ...submitBtn,
            color: "thirdly",
            fullWidth: false,
            action: async () => {
                const data = await submitBtn.action()
                if (data)
                    setAlert(false)
            }
        },
        {
            action: cleanForm,
            label: "ניקוי",
            color: "thirdly4"
        }
    ]

    return submitBtns
}

export default useSubmitBtns